// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ProductType } from './product-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProductTypeAlt extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key FK productType */
  productTypeId!: number;
  /** Int32 key FK altProductType */
  altProductTypeId!: number;
  /** Double */
  fitness!: number;
  /** Binary */
  rowVersion!: any;
  /** FK altProductTypeId */
  altProductType!: ProductType;
  /** FK productTypeId */
  productType!: ProductType;
}

